<template>
  <div class="c-editor-controls">
    <div class="c-editor-controls__header">
      <div v-if="scenarioId" class="c-editor-controls__button">
        <el-dropdown
          class="r-dropdown"
          size="mini"
          @command="startCalculationHandler"
        >
          <el-button
            class="r-button"
            type="primary"
            :disabled="scenarioStatus !== 'draft' || !!activeEventId"
            :loading="calculating"
          >
            {{ getStarterTitle }}
          </el-button>
          <el-dropdown-menu
            slot="dropdown"
            class="r-dropdown-menu c-calculations-dropdown"
          >
            <el-dropdown-item command="visum">
              <div class="r-dropdown-menu__item-wrapper">Расчет Visum</div>
            </el-dropdown-item>
            <el-dropdown-item :disabled="!matrices.length" command="due">
              <div class="r-dropdown-menu__item-wrapper">Расчет DUE</div>
            </el-dropdown-item>
            <el-dropdown-item command="sue">
              <div class="r-dropdown-menu__item-wrapper">Расчет SUE</div>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
      <div class="c-editor-controls__button">
        <el-button
          :disabled="!scenarioName || !!activeEventId"
          :loading="saving"
          class="r-button"
          type="success"
          @click="saveChanges"
        >
          Сохранить изменения
        </el-button>
        <el-button
          v-if="scenarioId"
          style="margin-left: 8px; width: auto"
          :disabled="!!activeEventId"
          :loading="deleting"
          circle
          type="danger"
          class="r-button icon-button"
          size="mini"
          @click="deleteScenario"
        >
          <r-icon name="trash" type="additional" :size="16" />
        </el-button>
      </div>
      <div v-if="isEdited" class="c-editor-controls__button">
        <el-button
          class="r-button"
          type="info"
          @click="clearChanges"
          :disabled="!!activeEventId"
        >
          Отменить изменения
        </el-button>
      </div>
    </div>
    <div class="c-editor-controls__attributes">
      <div class="c-editor-controls__attribute">
        <r-text type="caption" style="margin-bottom: 8px;">
          Название сценария
        </r-text>
        <el-input
          class="r-input"
          v-model="scenarioName"
          :disabled="!!activeEventId"
        />
      </div>
      <div v-if="scenarioStatus" class="c-editor-controls__attribute">
        <r-text type="caption" style="margin-bottom: 8px;">
          Статус расчета
        </r-text>
        <div class="c-editor-controls__attribute-value">
          <r-icon
            v-if="statusInfo"
            :name="statusInfo.icon"
            :size="14"
            style="margin-right: 8px;"
          />
          <r-text>
            {{ statusInfo.label }}
          </r-text>
        </div>
      </div>
    </div>
    <div class="c-editor-controls__events">
      <div class="c-editor-controls__modes">
        <r-text type="caption" style="margin-bottom: 8px;">
          Управление событиями
        </r-text>
        <r-radio-group
          :button-list="modes"
          :active="mode"
          :disabled="!!activeEventId"
          @change="changeMode"
        />
      </div>
      <event-list ref="eventList" />
    </div>
  </div>
</template>

<script>
import { notifyFactory } from "@/utils";
import EventList from "./event-list";

const modes = [
  { id: "create", label: "Создание" },
  { id: "edit", label: "Редактирование" }
];

export default {
  components: {
    EventList
  },
  data() {
    return {
      draw: this.$cControllers.editor.parent.draw,
      scenarioId: null,
      scenarioStatus: "draft",
      scenarioName: "",
      saving: false,
      deleting: false,
      calcParams: {
        start: 0,
        end: 86400,
        step_dnl: 300,
        step_due: 300,
        step_od: 300
      },
      model: this.$store.state.calculations.model,
      matrices: [],
      modes
    };
  },
  computed: {
    isEdited() {
      return this.scenarioName && this.$store.state.calculations.isEdited;
    },
    getStarterTitle() {
      if (this.calculating) return "Подготовка данных...";

      return "Запустить расчет";
    },
    calculating: {
      get() {
        return this.$store.state.calculations.calculating;
      },
      set(value) {
        this.$store.commit("SET_CALC_FIELD", {
          field: "calculating",
          value
        });
      }
    },
    mode() {
      return this.$store.state.calculations.editorState.mode;
    },
    activeEventId() {
      return this.$store.state.calculations.activeEventId;
    },
    statusInfo() {
      switch (this.scenarioStatus) {
        case "draft":
          return { label: "Черновик", icon: "edit-zone" };
        case "in_progress":
          return { label: "В процессе", icon: "in-process" };
        case "done":
          return { label: "Завершен", icon: "success" };
        default:
          return null;
      }
    }
  },
  methods: {
    changeMode(mode) {
      this.$cControllers.editor.toggleEditorMode(mode);
    },
    async getMatrices() {
      try {
        const { ids } = this.model;
        const id = ids["matrices"];
        const url = `objectInfo/${id}`;
        const { data } = await this.$store.dispatch("REQUEST", { url });

        this.matrices = Object.values(data);
      } catch (error) {
        console.log(error);
      }
    },
    startCalculationHandler(type) {
      this.startCalc(type);
    },
    getCalculationInfo(type) {
      switch (type) {
        case "visum":
          return {
            url: "worker/VisumProcess",
            name: "Visum"
          };
        case "due":
          return {
            url: "worker/DueProcess",
            name: "DUE"
          };
        case "sue":
          return {
            url: "worker/SueProcess",
            name: "SUE"
          };
        default:
          return null;
      }
    },
    async startCalc(type) {
      try {
        this.calculating = true;
        const data = new FormData();
        const source_id = this.model.id;
        const calcInfo = this.getCalculationInfo(type);
        if (!calcInfo) return;

        const { url, name } = calcInfo;

        data.append("source_id", source_id);
        data.append("name", this.scenarioName);

        const response = await this.$store.dispatch("SEND_FORM_DATA", {
          url,
          data
        });
        const { task_id } = response.data;

        this.$socket.once(`worker_info_${task_id}`, ({ status }) => {
          if (status === "data prepared") {
            const title = `Расчет ${name}`;
            const message =
              "Данные для расчета подготовлены. Начинается расчет...";
            this.$notify(notifyFactory("info", title, message));

            this.calculating = false;
            this.$router.push(`/app/calculations/${source_id}/list`);
          }
        });

        const title = `Расчет ${name}`;
        const message = "Расчет успешно запущен";
        this.$notify(notifyFactory("success", title, message));
      } catch (error) {
        console.log(error);
        this.calculating = false;
      }
    },
    async getCurrentBranch() {
      const { modelId } = this.$route.params;
      const url = `branch/${modelId}`;

      const { data } = await this.$store.dispatch("REQUEST", { url });

      if (data) {
        const { id, name, status } = data;

        this.scenarioId = id;
        this.scenarioName = name;
        this.scenarioStatus = status;
      }
    },
    async createBranch() {
      const { modelId } = this.$route.params;
      const url = `branch/${modelId}`;
      const data = {
        name: this.scenarioName
      };

      await this.$store.dispatch("POST_REQUEST", { url, data });
    },
    async saveEvents() {
      const { ids } = this.$store.state.calculations.model;
      const id = ids["events"];
      const { features } = this.draw.getAll();

      const url = `objectInfo/${id}`;
      const data = features
        .filter(f => f.geometry.coordinates.length)
        .map(f => ({ ...f.properties, geom: f.geometry }));

      await this.$store.dispatch("POST_REQUEST", { url, data });
      this.$cControllers.editor.clearEditingState();
      this.$refs.eventList.updateEvents();
    },
    async saveChanges() {
      try {
        this.saving = true;

        if (!this.scenarioId) {
          await this.createBranch();
          await this.getCurrentBranch();
          await this.$router.push({ query: { id: this.scenarioId } });
        }

        await this.saveEvents();
        await this.getMatrices();

        this.$store.commit("SET_CALC_FIELD", {
          field: "isEdited",
          value: false
        });

        this.saving = false;
      } catch (error) {
        console.log(error);
        this.saving = false;
      }
    },
    clearChanges() {
      this.$cControllers.editor.clearEditingState();
      this.$cControllers.editor.draw.deleteAll();
      this.$cControllers.editor.loadLayerData();
      this.$refs.eventList.updateEvents();

      this.$store.commit("SET_CALC_FIELD", {
        field: "isEdited",
        value: false
      });
    },
    async deleteScenario() {
      try {
        this.deleting = true;

        const source_id = this.model.id;
        const url = `branch?id=${this.scenarioId}`;
        await this.$store.dispatch("DELETE_REQUEST", { url });

        this.deleting = false;
        this.$router.push(`/app/calculations/${source_id}/list`);
      } catch (error) {
        console.log(error);
        this.deleting = false;
      }
    }
  },
  created() {
    const { id } = this.$route.query;

    if (id) {
      this.getCurrentBranch();
    }

    if (id) {
      this.getMatrices();
    }
  }
};
</script>

<style lang="scss">
.c-editor-controls {
  &__header {
    padding: 8px;
    border-bottom: 1px solid transparent;
    border-color: var(--dividers_low_contrast) !important;
  }

  &__button {
    display: flex;
    align-items: center;

    &:not(:first-child) {
      margin-top: 8px;
    }

    .r-button,
    .r-dropdown {
      width: 100%;
    }
  }

  &__attributes {
    padding: 8px;
    border-bottom: 1px solid transparent;
    border-color: var(--dividers_low_contrast) !important;
  }

  &__attribute {
    &-value {
      display: flex;
      align-items: center;
    }

    &:not(:first-child) {
      margin-top: 16px;
    }
  }

  &__modes {
    margin-bottom: 16px;
  }

  &__events {
    padding: 8px;
  }
}

.c-calculations-dropdown {
  width: 244px;
}
</style>
